<template>
  <div class="error-page">
      <div class="logo"></div>
      <div class="img-box">
          <img src="../assets/img/404.svg" alt="">
      </div>
      <p class="error-tips">服务器故障，网站暂停访问，技术人员正在修复，请稍后再来</p>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
.error-page{
    width: 100%;
    height: 100%;
    padding-top: 134px;
    .logo{
        width: 80px;
        height: 27px;
        background-image: url('../assets/img/logo-error.svg');
        background-size: 100% 100%;
        margin:auto;
    }
    .img-box{
        width: 612px;
        height: 299px;
        margin: 40px auto 16px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .error-tips{
        text-align: center;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #747990;
    }

}
</style>